import React, { useContext, useEffect, useState } from 'react';

import { Button, Typography } from '@material-ui/core';

import '../../components/Status.css';
import { useNavigate, useLocation } from 'react-router-dom';

import Basket from '../../components/checkout/Basket';
import DemoConsole from '../../components/demo-console/DemoConsole';
import { CheckoutContext, FlowsOptions } from '../../store/CheckoutContext';

interface Props {}

const Reject: React.FC<Props> = props => {
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState<any>({});
  const [demoMessages, setDemoMessages] = useState<string[]>([]);
  const { flow } = useContext(CheckoutContext);

  useEffect(() => {
    if (window?.location.pathname.includes('demo')) {
      const messagess = localStorage.getItem('demoMessages');
      if (messagess) {
        setDemoMessages(JSON.parse(messagess));
      }
    }
  }, []);

  useEffect(() => {
    const res = localStorage.getItem('state');
    res && setState(JSON.parse(res));
  }, []);

  const onButtonClick = () => {
    if (window?.location.pathname.includes('demo')) {
      navigate('/demo');
    } else {
      switch (flow) {
        case FlowsOptions.terminal:
          navigate('/terminal');
          break;
        case FlowsOptions.terminal:
          navigate('/checkout-steps');
          break;
        case FlowsOptions.withoutOrderId:
          navigate('/checkout-iframe-without-order-id');
          break;
        default:
          navigate('/checkout-iframe');
      }
    }
    localStorage.removeItem('state');
  };

  const cardNumber = state?.cardNumber && state?.cardNumber.slice(-4);

  return (
    <div className="Checkout decline">
      <DemoConsole isShow={demoMessages.length > 0} messages={demoMessages} />
      <div className="Confirmation Confirmation-error">
        <div className="content">
          <Typography variant="h4">Decline</Typography>
          <Typography className="block-title">Sorry, your payment was declined</Typography>
        </div>
      </div>
      <div className="complete-container">
        <div className="client-info-box">
          <div className="block">
            <div className="block-title">Billing address</div>
            <div className="block-text">
              {state?.billingFirstName} {state?.billingLastName}
            </div>
            <div className="block-text">{state?.billingAddressLine1}</div>
            <div className="block-text">
              {state?.billingCity}, {state?.billingZip}, {state?.billingCountry}
            </div>
            <div className="block-text">{state?.email}</div>
            <div className="block-text">{state?.phone}</div>
          </div>
          <div className="last-block">
            <div className="block-title">Payment</div>
            <div className="block-text ">
              <div className="cart-image">
                <img src="/images/visa.png" width={30} alt="visa" />
              </div>
              <div>
                {cardNumber} Exp: {state?.expirationMonth}/{state?.expirationYear}
              </div>
            </div>
            <div className="block-text">{state?.cardName}</div>
          </div>
        </div>
        <div className="order-info-box">
          <Basket />
        </div>
      </div>
      <div className="buttons">
        <Button variant="outlined" onClick={onButtonClick}>
          {window?.location.pathname.includes('demo') ? 'Back to home page' : 'Back to checkout'}
        </Button>
      </div>
    </div>
  );
};

export default Reject;
